@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(-2_113_587_056)
internal val Res.drawable.hy: DrawableResource by lazy {
      DrawableResource("drawable:hy", setOf(
        ResourceItem(setOf(), "${MD}drawable/hy.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_192_669_175)
internal val Res.drawable.ideograms: DrawableResource by lazy {
      DrawableResource("drawable:ideograms", setOf(
        ResourceItem(setOf(), "${MD}drawable/ideograms.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-422_327_692)
internal val Res.drawable.indiana: DrawableResource by lazy {
      DrawableResource("drawable:indiana", setOf(
        ResourceItem(setOf(), "${MD}drawable/indiana.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_025_226_076)
internal val Res.drawable.inpu: DrawableResource by lazy {
      DrawableResource("drawable:inpu", setOf(
        ResourceItem(setOf(), "${MD}drawable/inpu.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_214_379_334)
internal val Res.drawable.iten: DrawableResource by lazy {
      DrawableResource("drawable:iten", setOf(
        ResourceItem(setOf(), "${MD}drawable/iten.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_219_723_853)
internal val Res.drawable.left: DrawableResource by lazy {
      DrawableResource("drawable:left", setOf(
        ResourceItem(setOf(), "${MD}drawable/left.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(856_186_030)
internal val Res.drawable.left_right: DrawableResource by lazy {
      DrawableResource("drawable:left_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/left_right.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-892_626_252)
internal val Res.drawable.libro: DrawableResource by lazy {
      DrawableResource("drawable:libro", setOf(
        ResourceItem(setOf(), "${MD}drawable/libro.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(471_282_906)
internal val Res.drawable.lock: DrawableResource by lazy {
      DrawableResource("drawable:lock", setOf(
        ResourceItem(setOf(), "${MD}drawable/lock.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-171_119_652)
internal val Res.drawable.macchie: DrawableResource by lazy {
      DrawableResource("drawable:macchie", setOf(
        ResourceItem(setOf(), "${MD}drawable/macchie.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_469_155_365)
internal val Res.drawable.mano: DrawableResource by lazy {
      DrawableResource("drawable:mano", setOf(
        ResourceItem(setOf(), "${MD}drawable/mano.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(870_115_422)
internal val Res.drawable.masko_0_collo: DrawableResource by lazy {
      DrawableResource("drawable:masko_0_collo", setOf(
        ResourceItem(setOf(), "${MD}drawable/masko_0_collo.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_342_701_066)
internal val Res.drawable.masko_1_orecchie_back: DrawableResource by lazy {
      DrawableResource("drawable:masko_1_orecchie_back", setOf(
        ResourceItem(setOf(), "${MD}drawable/masko_1_orecchie_back.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-651_648_175)
internal val Res.drawable.masko_2_orecchie_front: DrawableResource by lazy {
      DrawableResource("drawable:masko_2_orecchie_front", setOf(
        ResourceItem(setOf(), "${MD}drawable/masko_2_orecchie_front.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_016_982_535)
internal val Res.drawable.masko_3_corpo: DrawableResource by lazy {
      DrawableResource("drawable:masko_3_corpo", setOf(
        ResourceItem(setOf(), "${MD}drawable/masko_3_corpo.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(563_185_482)
internal val Res.drawable.masko_4_antenne: DrawableResource by lazy {
      DrawableResource("drawable:masko_4_antenne", setOf(
        ResourceItem(setOf(), "${MD}drawable/masko_4_antenne.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_409_127_621)
internal val Res.drawable.masko_5_occhi: DrawableResource by lazy {
      DrawableResource("drawable:masko_5_occhi", setOf(
        ResourceItem(setOf(), "${MD}drawable/masko_5_occhi.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_023_660_324)
internal val Res.drawable.masko_6_occhiali: DrawableResource by lazy {
      DrawableResource("drawable:masko_6_occhiali", setOf(
        ResourceItem(setOf(), "${MD}drawable/masko_6_occhiali.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_058_496_518)
internal val Res.drawable.masko_7_baffi: DrawableResource by lazy {
      DrawableResource("drawable:masko_7_baffi", setOf(
        ResourceItem(setOf(), "${MD}drawable/masko_7_baffi.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_075_096_274)
internal val Res.drawable.masko_8_naso: DrawableResource by lazy {
      DrawableResource("drawable:masko_8_naso", setOf(
        ResourceItem(setOf(), "${MD}drawable/masko_8_naso.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-873_394_946)
internal val Res.drawable.masko_9_sopracciglia: DrawableResource by lazy {
      DrawableResource("drawable:masko_9_sopracciglia", setOf(
        ResourceItem(setOf(), "${MD}drawable/masko_9_sopracciglia.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(855_764_685)
internal val Res.drawable.masko_base: DrawableResource by lazy {
      DrawableResource("drawable:masko_base", setOf(
        ResourceItem(setOf(), "${MD}drawable/masko_base.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(353_873_767)
internal val Res.drawable.masko_einstein: DrawableResource by lazy {
      DrawableResource("drawable:masko_einstein", setOf(
        ResourceItem(setOf(), "${MD}drawable/masko_einstein.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_307_153_207)
internal val Res.drawable.masko_einstein_baffi: DrawableResource by lazy {
      DrawableResource("drawable:masko_einstein_baffi", setOf(
        ResourceItem(setOf(), "${MD}drawable/masko_einstein_baffi.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_089_631_154)
internal val Res.drawable.masko_einstein_capelli: DrawableResource by lazy {
      DrawableResource("drawable:masko_einstein_capelli", setOf(
        ResourceItem(setOf(), "${MD}drawable/masko_einstein_capelli.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(70_561_423)
internal val Res.drawable.masko_einstein_occhiali: DrawableResource by lazy {
      DrawableResource("drawable:masko_einstein_occhiali", setOf(
        ResourceItem(setOf(), "${MD}drawable/masko_einstein_occhiali.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_048_856_690)
internal val Res.drawable.masko_layer_sad: DrawableResource by lazy {
      DrawableResource("drawable:masko_layer_sad", setOf(
        ResourceItem(setOf(), "${MD}drawable/masko-layer-sad.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(723_903_600)
internal val Res.drawable.masko_layer_surprised: DrawableResource by lazy {
      DrawableResource("drawable:masko_layer_surprised", setOf(
        ResourceItem(setOf(), "${MD}drawable/masko-layer-surprised.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(369_229_343)
internal val Res.drawable.masko_pirate_hat: DrawableResource by lazy {
      DrawableResource("drawable:masko_pirate_hat", setOf(
        ResourceItem(setOf(), "${MD}drawable/masko_pirate_hat.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(508_271_285)
internal val Res.drawable.masko_pirate_occhiali: DrawableResource by lazy {
      DrawableResource("drawable:masko_pirate_occhiali", setOf(
        ResourceItem(setOf(), "${MD}drawable/masko_pirate_occhiali.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(848_073_475)
internal val Res.drawable.masko_rich_hat: DrawableResource by lazy {
      DrawableResource("drawable:masko_rich_hat", setOf(
        ResourceItem(setOf(), "${MD}drawable/masko_rich_hat.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_812_678_827)
internal val Res.drawable.masko_rich_occhiali: DrawableResource by lazy {
      DrawableResource("drawable:masko_rich_occhiali", setOf(
        ResourceItem(setOf(), "${MD}drawable/masko_rich_occhiali.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(68_574_260)
internal val Res.drawable.mentuhotep: DrawableResource by lazy {
      DrawableResource("drawable:mentuhotep", setOf(
        ResourceItem(setOf(), "${MD}drawable/mentuhotep.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-571_174_190)
internal val Res.drawable.menu_book: DrawableResource by lazy {
      DrawableResource("drawable:menu_book", setOf(
        ResourceItem(setOf(), "${MD}drawable/menu_book.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-79_623_321)
internal val Res.drawable.mib_mistery: DrawableResource by lazy {
      DrawableResource("drawable:mib_mistery", setOf(
        ResourceItem(setOf(), "${MD}drawable/mib_mistery.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_793_950_691)
internal val Res.drawable.miit: DrawableResource by lazy {
      DrawableResource("drawable:miit", setOf(
        ResourceItem(setOf(), "${MD}drawable/miit.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_982_232_608)
internal val Res.drawable.neferhotep: DrawableResource by lazy {
      DrawableResource("drawable:neferhotep", setOf(
        ResourceItem(setOf(), "${MD}drawable/neferhotep.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(793_404_748)
internal val Res.drawable.nilo_layer_0_body: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_0_body", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-0-body.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(843_837_430)
internal val Res.drawable.nilo_layer_1_ear_back_left: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_1_ear_back_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-1-ear-back-left.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_052_097_245)
internal val Res.drawable.nilo_layer_1_ear_back_right: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_1_ear_back_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-1-ear-back-right.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_377_204_335)
internal val Res.drawable.nilo_layer_2_ear_mid: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_2_ear_mid", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-2-ear-mid.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_145_479_333)
internal val Res.drawable.nilo_layer_3_ear_top: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_3_ear_top", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-3-ear-top.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_314_278_801)
internal val Res.drawable.nilo_layer_4_head: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_4_head", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-4-head.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_734_000_281)
internal val Res.drawable.nilo_layer_5_macchia_left: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_5_macchia_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-5-macchia-left.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_954_603_433)
internal val Res.drawable.nilo_layer_5_macchia_left_tigrato: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_5_macchia_left_tigrato", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-5-macchia-left-tigrato.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_322_755_116)
internal val Res.drawable.nilo_layer_5_macchia_right: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_5_macchia_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-5-macchia-right.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_663_132_157)
internal val Res.drawable.nilo_layer_5_macchia_right_tigrato: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_5_macchia_right_tigrato", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-5-macchia-right-tigrato.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_100_920_446)
internal val Res.drawable.nilo_layer_5_macchia_tuxedo: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_5_macchia_tuxedo", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-5-macchia-tuxedo.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-450_139_795)
internal val Res.drawable.nilo_layer_6_idle_baffi: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_6_idle_baffi", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-6-idle-baffi.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_867_441_614)
internal val Res.drawable.nilo_layer_6_idle_bocca_back: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_6_idle_bocca_back", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-6-idle-bocca-back.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_288_309_680)
internal val Res.drawable.nilo_layer_6_idle_bocca_blockers: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_6_idle_bocca_blockers", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-6-idle-bocca-blockers.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(58_722_064)
internal val Res.drawable.nilo_layer_6_idle_bocca_over: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_6_idle_bocca_over", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-6-idle-bocca-over.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_115_066_184)
internal val Res.drawable.nilo_layer_6_idle_guance: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_6_idle_guance", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-6-idle-guance.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_909_355_186)
internal val Res.drawable.nilo_layer_6_idle_naso: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_6_idle_naso", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-6-idle-naso.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-89_067_161)
internal val Res.drawable.nilo_layer_6_idle_occhi_back: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_6_idle_occhi_back", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-6-idle-occhi-back.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_685_140_793)
internal val Res.drawable.nilo_layer_6_idle_occhi_mid: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_6_idle_occhi_mid", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-6-idle-occhi-mid.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_619_524_560)
internal val Res.drawable.nilo_layer_6_idle_occhi_top: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_6_idle_occhi_top", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-6-idle-occhi-top.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_363_152_215)
internal val Res.drawable.nilo_layer_6_sad_bocca_back: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_6_sad_bocca_back", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-6-sad-bocca-back.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(574_604_311)
internal val Res.drawable.nilo_layer_6_sad_bocca_over: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_6_sad_bocca_over", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-6-sad-bocca-over.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(725_370_923)
internal val Res.drawable.nilo_layer_6_sleeping_bocca: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_6_sleeping_bocca", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-6-sleeping-bocca.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_128_111_279)
internal val Res.drawable.nilo_layer_6_sleeping_occhi: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_6_sleeping_occhi", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-6-sleeping-occhi.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-350_878_959)
internal val Res.drawable.nilo_layer_6_surprised_bocca_back: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_6_surprised_bocca_back", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-6-surprised-bocca-back.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-620_946_608)
internal val Res.drawable.nilo_layer_6_surprised_bocca_over: DrawableResource by lazy {
      DrawableResource("drawable:nilo_layer_6_surprised_bocca_over", setOf(
        ResourceItem(setOf(), "${MD}drawable/nilo-layer-6-surprised-bocca-over.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-149_332_807)
internal val Res.drawable.occhio: DrawableResource by lazy {
      DrawableResource("drawable:occhio", setOf(
        ResourceItem(setOf(), "${MD}drawable/occhio.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(351_988_501)
internal val Res.drawable.osiride: DrawableResource by lazy {
      DrawableResource("drawable:osiride", setOf(
        ResourceItem(setOf(), "${MD}drawable/osiride.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-92_631_705)
internal val Res.drawable.pane: DrawableResource by lazy {
      DrawableResource("drawable:pane", setOf(
        ResourceItem(setOf(), "${MD}drawable/pane.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-859_037_683)
internal val Res.drawable.panno: DrawableResource by lazy {
      DrawableResource("drawable:panno", setOf(
        ResourceItem(setOf(), "${MD}drawable/panno.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-180_690_806)
internal val Res.drawable.pastoie: DrawableResource by lazy {
      DrawableResource("drawable:pastoie", setOf(
        ResourceItem(setOf(), "${MD}drawable/pastoie.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_457_067_790)
internal val Res.drawable.perc: DrawableResource by lazy {
      DrawableResource("drawable:perc", setOf(
        ResourceItem(setOf(), "${MD}drawable/perc.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_718_553_400)
internal val Res.drawable.person: DrawableResource by lazy {
      DrawableResource("drawable:person", setOf(
        ResourceItem(setOf(), "${MD}drawable/person.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_187_042_750)
internal val Res.drawable.piantina_edificio: DrawableResource by lazy {
      DrawableResource("drawable:piantina_edificio", setOf(
        ResourceItem(setOf(), "${MD}drawable/piantina_edificio.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_247_240_985)
internal val Res.drawable.pirate: DrawableResource by lazy {
      DrawableResource("drawable:pirate", setOf(
        ResourceItem(setOf(), "${MD}drawable/pirate.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_919_868_909)
internal val Res.drawable.pixel: DrawableResource by lazy {
      DrawableResource("drawable:pixel", setOf(
        ResourceItem(setOf(), "${MD}drawable/pixel.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_698_594_345)
internal val Res.drawable.placenta: DrawableResource by lazy {
      DrawableResource("drawable:placenta", setOf(
        ResourceItem(setOf(), "${MD}drawable/placenta.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_314_925_533)
internal val Res.drawable.ptah: DrawableResource by lazy {
      DrawableResource("drawable:ptah", setOf(
        ResourceItem(setOf(), "${MD}drawable/ptah.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(386_114_754)
internal val Res.drawable.pulcino_quaglia: DrawableResource by lazy {
      DrawableResource("drawable:pulcino_quaglia", setOf(
        ResourceItem(setOf(), "${MD}drawable/pulcino_quaglia.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-844_781_200)
internal val Res.drawable.ramses: DrawableResource by lazy {
      DrawableResource("drawable:ramses", setOf(
        ResourceItem(setOf(), "${MD}drawable/ramses.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_187_492_826)
internal val Res.drawable.re_basso: DrawableResource by lazy {
      DrawableResource("drawable:re_basso", setOf(
        ResourceItem(setOf(), "${MD}drawable/re_basso.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-458_227_665)
internal val Res.drawable.rejoyce: DrawableResource by lazy {
      DrawableResource("drawable:rejoyce", setOf(
        ResourceItem(setOf(), "${MD}drawable/rejoyce.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-203_037_916)
internal val Res.drawable.ri00182: DrawableResource by lazy {
      DrawableResource("drawable:ri00182", setOf(
        ResourceItem(setOf(), "${MD}drawable/ri00182.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_651_552_931)
internal val Res.drawable.ri00200: DrawableResource by lazy {
      DrawableResource("drawable:ri00200", setOf(
        ResourceItem(setOf(), "${MD}drawable/ri00200.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_677_143_052)
internal val Res.drawable.rich: DrawableResource by lazy {
      DrawableResource("drawable:rich", setOf(
        ResourceItem(setOf(), "${MD}drawable/rich.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_082_471_895)
internal val Res.drawable.rigagnolo_acqua: DrawableResource by lazy {
      DrawableResource("drawable:rigagnolo_acqua", setOf(
        ResourceItem(setOf(), "${MD}drawable/rigagnolo_acqua.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(680_691_760)
internal val Res.drawable.right_left: DrawableResource by lazy {
      DrawableResource("drawable:right_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/right_left.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(247_045_801)
internal val Res.drawable.roast: DrawableResource by lazy {
      DrawableResource("drawable:roast", setOf(
        ResourceItem(setOf(), "${MD}drawable/roast.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(61_233_768)
internal val Res.drawable.roast_reading: DrawableResource by lazy {
      DrawableResource("drawable:roast_reading", setOf(
        ResourceItem(setOf(), "${MD}drawable/roast_reading.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_090_489_963)
internal val Res.drawable.same_size: DrawableResource by lazy {
      DrawableResource("drawable:same_size", setOf(
        ResourceItem(setOf(), "${MD}drawable/same_size.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_918_838_371)
internal val Res.drawable.scriba_seduto: DrawableResource by lazy {
      DrawableResource("drawable:scriba_seduto", setOf(
        ResourceItem(setOf(), "${MD}drawable/scriba_seduto.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-941_463_981)
internal val Res.drawable.scribe: DrawableResource by lazy {
      DrawableResource("drawable:scribe", setOf(
        ResourceItem(setOf(), "${MD}drawable/scribe.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_030_467_257)
internal val Res.drawable.seggiola: DrawableResource by lazy {
      DrawableResource("drawable:seggiola", setOf(
        ResourceItem(setOf(), "${MD}drawable/seggiola.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-925_586_890)
internal val Res.drawable.segni: DrawableResource by lazy {
      DrawableResource("drawable:segni", setOf(
        ResourceItem(setOf(), "${MD}drawable/segni.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_622_303_013)
internal val Res.drawable.snefru: DrawableResource by lazy {
      DrawableResource("drawable:snefru", setOf(
        ResourceItem(setOf(), "${MD}drawable/snefru.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_011_545_371)
internal val Res.drawable.sole: DrawableResource by lazy {
      DrawableResource("drawable:sole", setOf(
        ResourceItem(setOf(), "${MD}drawable/sole.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-590_070_743)
internal val Res.drawable.sostegno_vaso_1: DrawableResource by lazy {
      DrawableResource("drawable:sostegno_vaso_1", setOf(
        ResourceItem(setOf(), "${MD}drawable/sostegno_vaso_1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(22_198_391)
internal val Res.drawable.sostegno_vaso_2: DrawableResource by lazy {
      DrawableResource("drawable:sostegno_vaso_2", setOf(
        ResourceItem(setOf(), "${MD}drawable/sostegno_vaso_2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-908_012_473)
internal val Res.drawable.space: DrawableResource by lazy {
      DrawableResource("drawable:space", setOf(
        ResourceItem(setOf(), "${MD}drawable/space.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_071_510_729)
internal val Res.drawable.squares: DrawableResource by lazy {
      DrawableResource("drawable:squares", setOf(
        ResourceItem(setOf(), "${MD}drawable/squares.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-666_938_360)
internal val Res.drawable.stella: DrawableResource by lazy {
      DrawableResource("drawable:stella", setOf(
        ResourceItem(setOf(), "${MD}drawable/stella.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_171_056_692)
internal val Res.drawable.stella_cerchio: DrawableResource by lazy {
      DrawableResource("drawable:stella_cerchio", setOf(
        ResourceItem(setOf(), "${MD}drawable/stella_cerchio.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_285_306_473)
internal val Res.drawable.stella_full: DrawableResource by lazy {
      DrawableResource("drawable:stella_full", setOf(
        ResourceItem(setOf(), "${MD}drawable/stella_full.webp", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable12Resources(map: MutableMap<String, DrawableResource>) {
  map.put("hy", Res.drawable.hy)
  map.put("ideograms", Res.drawable.ideograms)
  map.put("indiana", Res.drawable.indiana)
  map.put("inpu", Res.drawable.inpu)
  map.put("iten", Res.drawable.iten)
  map.put("left", Res.drawable.left)
  map.put("left_right", Res.drawable.left_right)
  map.put("libro", Res.drawable.libro)
  map.put("lock", Res.drawable.lock)
  map.put("macchie", Res.drawable.macchie)
  map.put("mano", Res.drawable.mano)
  map.put("masko_0_collo", Res.drawable.masko_0_collo)
  map.put("masko_1_orecchie_back", Res.drawable.masko_1_orecchie_back)
  map.put("masko_2_orecchie_front", Res.drawable.masko_2_orecchie_front)
  map.put("masko_3_corpo", Res.drawable.masko_3_corpo)
  map.put("masko_4_antenne", Res.drawable.masko_4_antenne)
  map.put("masko_5_occhi", Res.drawable.masko_5_occhi)
  map.put("masko_6_occhiali", Res.drawable.masko_6_occhiali)
  map.put("masko_7_baffi", Res.drawable.masko_7_baffi)
  map.put("masko_8_naso", Res.drawable.masko_8_naso)
  map.put("masko_9_sopracciglia", Res.drawable.masko_9_sopracciglia)
  map.put("masko_base", Res.drawable.masko_base)
  map.put("masko_einstein", Res.drawable.masko_einstein)
  map.put("masko_einstein_baffi", Res.drawable.masko_einstein_baffi)
  map.put("masko_einstein_capelli", Res.drawable.masko_einstein_capelli)
  map.put("masko_einstein_occhiali", Res.drawable.masko_einstein_occhiali)
  map.put("masko_layer_sad", Res.drawable.masko_layer_sad)
  map.put("masko_layer_surprised", Res.drawable.masko_layer_surprised)
  map.put("masko_pirate_hat", Res.drawable.masko_pirate_hat)
  map.put("masko_pirate_occhiali", Res.drawable.masko_pirate_occhiali)
  map.put("masko_rich_hat", Res.drawable.masko_rich_hat)
  map.put("masko_rich_occhiali", Res.drawable.masko_rich_occhiali)
  map.put("mentuhotep", Res.drawable.mentuhotep)
  map.put("menu_book", Res.drawable.menu_book)
  map.put("mib_mistery", Res.drawable.mib_mistery)
  map.put("miit", Res.drawable.miit)
  map.put("neferhotep", Res.drawable.neferhotep)
  map.put("nilo_layer_0_body", Res.drawable.nilo_layer_0_body)
  map.put("nilo_layer_1_ear_back_left", Res.drawable.nilo_layer_1_ear_back_left)
  map.put("nilo_layer_1_ear_back_right", Res.drawable.nilo_layer_1_ear_back_right)
  map.put("nilo_layer_2_ear_mid", Res.drawable.nilo_layer_2_ear_mid)
  map.put("nilo_layer_3_ear_top", Res.drawable.nilo_layer_3_ear_top)
  map.put("nilo_layer_4_head", Res.drawable.nilo_layer_4_head)
  map.put("nilo_layer_5_macchia_left", Res.drawable.nilo_layer_5_macchia_left)
  map.put("nilo_layer_5_macchia_left_tigrato", Res.drawable.nilo_layer_5_macchia_left_tigrato)
  map.put("nilo_layer_5_macchia_right", Res.drawable.nilo_layer_5_macchia_right)
  map.put("nilo_layer_5_macchia_right_tigrato", Res.drawable.nilo_layer_5_macchia_right_tigrato)
  map.put("nilo_layer_5_macchia_tuxedo", Res.drawable.nilo_layer_5_macchia_tuxedo)
  map.put("nilo_layer_6_idle_baffi", Res.drawable.nilo_layer_6_idle_baffi)
  map.put("nilo_layer_6_idle_bocca_back", Res.drawable.nilo_layer_6_idle_bocca_back)
  map.put("nilo_layer_6_idle_bocca_blockers", Res.drawable.nilo_layer_6_idle_bocca_blockers)
  map.put("nilo_layer_6_idle_bocca_over", Res.drawable.nilo_layer_6_idle_bocca_over)
  map.put("nilo_layer_6_idle_guance", Res.drawable.nilo_layer_6_idle_guance)
  map.put("nilo_layer_6_idle_naso", Res.drawable.nilo_layer_6_idle_naso)
  map.put("nilo_layer_6_idle_occhi_back", Res.drawable.nilo_layer_6_idle_occhi_back)
  map.put("nilo_layer_6_idle_occhi_mid", Res.drawable.nilo_layer_6_idle_occhi_mid)
  map.put("nilo_layer_6_idle_occhi_top", Res.drawable.nilo_layer_6_idle_occhi_top)
  map.put("nilo_layer_6_sad_bocca_back", Res.drawable.nilo_layer_6_sad_bocca_back)
  map.put("nilo_layer_6_sad_bocca_over", Res.drawable.nilo_layer_6_sad_bocca_over)
  map.put("nilo_layer_6_sleeping_bocca", Res.drawable.nilo_layer_6_sleeping_bocca)
  map.put("nilo_layer_6_sleeping_occhi", Res.drawable.nilo_layer_6_sleeping_occhi)
  map.put("nilo_layer_6_surprised_bocca_back", Res.drawable.nilo_layer_6_surprised_bocca_back)
  map.put("nilo_layer_6_surprised_bocca_over", Res.drawable.nilo_layer_6_surprised_bocca_over)
  map.put("occhio", Res.drawable.occhio)
  map.put("osiride", Res.drawable.osiride)
  map.put("pane", Res.drawable.pane)
  map.put("panno", Res.drawable.panno)
  map.put("pastoie", Res.drawable.pastoie)
  map.put("perc", Res.drawable.perc)
  map.put("person", Res.drawable.person)
  map.put("piantina_edificio", Res.drawable.piantina_edificio)
  map.put("pirate", Res.drawable.pirate)
  map.put("pixel", Res.drawable.pixel)
  map.put("placenta", Res.drawable.placenta)
  map.put("ptah", Res.drawable.ptah)
  map.put("pulcino_quaglia", Res.drawable.pulcino_quaglia)
  map.put("ramses", Res.drawable.ramses)
  map.put("re_basso", Res.drawable.re_basso)
  map.put("rejoyce", Res.drawable.rejoyce)
  map.put("ri00182", Res.drawable.ri00182)
  map.put("ri00200", Res.drawable.ri00200)
  map.put("rich", Res.drawable.rich)
  map.put("rigagnolo_acqua", Res.drawable.rigagnolo_acqua)
  map.put("right_left", Res.drawable.right_left)
  map.put("roast", Res.drawable.roast)
  map.put("roast_reading", Res.drawable.roast_reading)
  map.put("same_size", Res.drawable.same_size)
  map.put("scriba_seduto", Res.drawable.scriba_seduto)
  map.put("scribe", Res.drawable.scribe)
  map.put("seggiola", Res.drawable.seggiola)
  map.put("segni", Res.drawable.segni)
  map.put("snefru", Res.drawable.snefru)
  map.put("sole", Res.drawable.sole)
  map.put("sostegno_vaso_1", Res.drawable.sostegno_vaso_1)
  map.put("sostegno_vaso_2", Res.drawable.sostegno_vaso_2)
  map.put("space", Res.drawable.space)
  map.put("squares", Res.drawable.squares)
  map.put("stella", Res.drawable.stella)
  map.put("stella_cerchio", Res.drawable.stella_cerchio)
  map.put("stella_full", Res.drawable.stella_full)
}
